/* eslint-disable */
import WATER_ACTIVITIES_REPOSITORY
    from '@/js/common/components/filterCriteria/waterActivities/WaterActivitiesRepository';
import ResortsRepository from '@/js/common/Domain/Repository/Resorts';
import CountriesRepository from '@/js/common/Domain/Repository/Countries';
import errorHandlerService from '@/js/common/Domain/Service/errorHandler';
import HotelCategoriesRepository from '@/js/common/Domain/Repository/HotelCategories';
import TourProductsRepository from '@/js/common/Domain/Repository/TourProducts';
import HotelOffersRepository from '@/js/common/Domain/Repository/HotelOffers';
import { getChildService, getRestType, getBeachType, getRenovationTypes } from '@entities/hotel';

import {
    getDateOfLastHotelChange,
    getPropertyWaterActivities,
    getPropertyTypeDistanceLift,
    getPropertyFacilitiesAttributes
} from './helpers';

export default (data, localCountriesRepository) => {
    const hotel = {};
    let resort;
    let country;
    let element;

    element = data.id;
    if (typeof element !== 'undefined') {
        hotel.id = element;
        hotel.url = `/goto/hotel/${element}`;
    }

    element = data.userInterestGroups;
    if (typeof element !== 'undefined') {
        hotel.userInterestGroups = element;
    }

    element = data.name;
    if (typeof element !== 'undefined') {
        hotel.name = element;
    }

    element = data.coords;
    if (typeof element !== 'undefined') {
        hotel.map = {
            lat: element.latitude || element.lat,
            lon: element.longitude || element.lon,
        };
    }

    element = data.rating || 0;
    if (typeof element !== 'undefined') {
        hotel.rating = element;

        if (data.rating && data.rating.toFixed(1) >= 3.8 && data.reviewsQty > 5) {
            hotel.highlyRated = true;
        }
    }

    element = data.ratingDetails;
    if (typeof element !== 'undefined') {
        hotel.ratingDetails = element;
    }

    element = data.reviewsNumber;
    if (typeof element !== 'undefined') {
        hotel.reviewsQty = element;
    }

    element = data.toursQuantity;
    if (typeof element !== 'undefined') {
        hotel.toursQuantity = element;
    }

    element = data.photos;
    if (typeof element !== 'undefined') {
        hotel.photos = element;
    }

    element = data.cover;
    if (typeof element !== 'undefined') {
        hotel.cover = element;
    }

    element = data.ordersNumber;
    if (typeof element !== 'undefined') {
        hotel.ordersCount = element;
    }

    element = data.resort;
    if (typeof element !== 'undefined') {
        resort = ResortsRepository.repository.get(element);
        if (typeof (resort) === 'undefined' && ResortsRepository.repository.length) {
            errorHandlerService(`No resort with id ${resort} but found in hotel`);
        }
        hotel.resort = resort || element;
    }

    element = data.country;
    if (typeof element !== 'undefined') {
        const repository = localCountriesRepository
            ? localCountriesRepository
            : CountriesRepository.repository;

        country = repository.get(element) ?? CountriesRepository.repository.get(element);

        if (typeof (country) === 'undefined' && repository.length) {
            errorHandlerService(`No country with id ${element} but found in hotel`);
        }
        hotel.country = country || element;
    }

    element = data.hotelCategory;
    if (element) {
        let hotelCategory = HotelCategoriesRepository.repository.get(element);
        if (!hotelCategory && typeof element === 'number') {
            hotelCategory = HotelCategoriesRepository.repository.get(0);
        }
        hotel.category = hotelCategory || element;
    }

    element = data.types;
    hotel.restTypes = getRestType(element);
    if (typeof element !== 'undefined') {
        // Один Set по types вместо шести линейных _.contains.
        const typeIds = new Set(element);
        hotel.withKids = typeIds.has(5);
        hotel.forCouples = typeIds.has(8);
        hotel.cityTours = typeIds.has(2);
        hotel.wellness = typeIds.has(4);
        hotel.mountains = typeIds.has(3);
        hotel.eco = typeIds.has(11);
    }

    element = data.beachLine;
    if (element) {
        hotel.beachLine = element;
    }

    hotel.dateOfLastHotelChange = getDateOfLastHotelChange(data.builtDate, data.renovationDate);
    hotel.builtDate = data.builtDate;
    hotel.renovationDate = data.renovationDate;
    hotel.renovationTypes = getRenovationTypes(data);
    hotel.beachOwner = !!~data.attributes?.indexOf(134);
    hotel.excursions = data.hotelCategory === 23;

    element = data.attributes;
    if (typeof element !== 'undefined') {
        // Один Set по attributes вместо десятков линейных _.contains/indexOf ниже.
        const attributeIds = new Set(element);

        hotel.airConditioner = attributeIds.has(83) || attributeIds.has(212) || attributeIds.has(233);
        hotel.wifi = attributeIds.has(74) || attributeIds.has(88) || attributeIds.has(226) || attributeIds.has(227) || attributeIds.has(234) || attributeIds.has(237);
        hotel.nearTheLift = attributeIds.has(213) || attributeIds.has(225);
        hotel.sandBeach = attributeIds.has(136);
        hotel.pebbleBeach = attributeIds.has(137);
        hotel.sandPebbleBeach = attributeIds.has(211);
        hotel.adultsOnly = attributeIds.has(217);
        hotel.bayLocated = attributeIds.has(264);
        hotel.parking = attributeIds.has(69) || attributeIds.has(263);
        hotel.saunaBathHammam = attributeIds.has(148) || attributeIds.has(149);
        hotel.forCouples = hotel.forCouples
            || attributeIds.has(169)
            || attributeIds.has(220)
            || attributeIds.has(217);

        hotel.beachType = getBeachType(element);

        hotel.distanceLift = getPropertyTypeDistanceLift(element);
        hotel.waterActivities = getPropertyWaterActivities(element);
        hotel.childServices = getChildService(element);
        hotel.children_animators = attributeIds.has(229);
        hotel.children_pool = attributeIds.has(111);
        hotel.children_waterslides = attributeIds.has(175);
        hotel.children_aquapark = attributeIds.has(61);
        hotel.children_playroom = attributeIds.has(109);
        hotel.lonelyMan = !attributeIds.has(250);
        hotel.jacuzzi = attributeIds.has(185) || attributeIds.has(64);
        hotel.children_seaEnter = hotel.sandBeach
            && hotel.withKids
            && !hotel.pebbleBeach
            && !hotel.sandPebbleBeach
            && !attributeIds.has(138)
            && !attributeIds.has(139)
            && !attributeIds.has(140);

        hotel.children_childmenu = attributeIds.has(163);
        hotel.children_childBed = attributeIds.has(114) || attributeIds.has(246) || attributeIds.has(247); //346
        hotel.children_nanny = attributeIds.has(113) || attributeIds.has(110);
        hotel.children_clubs = attributeIds.has(112);
        hotel.withKids = hotel.withKids
            || attributeIds.has(109)
            || attributeIds.has(229)
            || hotel.children_clubs
            || hotel.children_animators;
        hotel.nearTheLiftDescription = '';
        hotel.conditionerDescription = '';

        // Кондиционер (бесплатно) - 83
        // Кондиционер (платно) - 212
        // Кондиционер (нет данных о стоимости) - 233

        if (attributeIds.has(83)) {
            hotel.conditionerDescription = 'Бесплатно';
        }
        if (attributeIds.has(212)) {
            hotel.conditionerDescription = 'Платно';
        }
        if (attributeIds.has(233)) {
            hotel.conditionerDescription = '';
        }

        hotel.wifiDescription = '';
        //Интернет в номере (платно); 74
        //Интернет в номере (бесплатно); 226
        //Интернет в номере (нет данных о стоимости); 234
        //Интернет/Wi-Fi на территории (платно); 88
        //Интернет/Wi-Fi на территории (бесплатно); 227
        //Интернет/Wi-Fi на территории (нет данных о стоимости); 237
        const roomPaid = attributeIds.has(74);
        const roomFree = attributeIds.has(226);
        const roomUnknown = attributeIds.has(234);
        const lobbyPaid = attributeIds.has(88);
        const lobbyFree = attributeIds.has(227);
        const lobbyUnknown = attributeIds.has(237);
        if (roomPaid && !roomFree && !roomUnknown && lobbyPaid && !lobbyFree && !lobbyUnknown) {
            hotel.wifiDescription = 'В номере платно, в лобби платно';
        }
        if (roomPaid && !roomFree && !roomUnknown && !lobbyPaid && lobbyFree && !lobbyUnknown) {
            hotel.wifiDescription = 'В номере платно, в лобби бесплатно';
        }
        if (roomPaid && !roomFree && !roomUnknown && !lobbyPaid && !lobbyFree && lobbyUnknown) {
            hotel.wifiDescription = 'В номере есть, в лобби есть';
        }
        if (!roomPaid && roomFree && !roomUnknown && lobbyPaid && !lobbyFree && !lobbyUnknown) {
            hotel.wifiDescription = 'В номере бесплатно, в лобби платно';
        }
        if (!roomPaid && roomFree && !roomUnknown && !lobbyPaid && lobbyFree && !lobbyUnknown) {
            hotel.wifiDescription = 'В номере бесплатно, в лобби бесплатно';
        }
        if (!roomPaid && roomFree && !roomUnknown && !lobbyPaid && !lobbyFree && lobbyUnknown) {
            hotel.wifiDescription = 'В номере есть, в лобби есть';
        }
        if (!roomPaid && !roomFree && roomUnknown && lobbyPaid && !lobbyFree && !lobbyUnknown) {
            hotel.wifiDescription = 'В номере есть, в лобби платно';
        }
        if (!roomPaid && !roomFree && roomUnknown && !lobbyPaid && lobbyFree && !lobbyUnknown) {
            hotel.wifiDescription = 'В номере есть, в лобби бесплатно';
        }
        if (!roomPaid && !roomFree && roomUnknown && !lobbyPaid && !lobbyFree && lobbyUnknown) {
            hotel.wifiDescription = 'В номере есть, в лобби есть';
        }
        if (!roomPaid && !roomFree && !roomUnknown && lobbyPaid && !lobbyFree && !lobbyUnknown) {
            hotel.wifiDescription = 'В номере нет, в лобби платно';
        }
        if (!roomPaid && !roomFree && !roomUnknown && !lobbyPaid && lobbyFree && !lobbyUnknown) {
            hotel.wifiDescription = 'В номере нет, в лобби бесплатно';
        }
        if (!roomPaid && !roomFree && !roomUnknown && !lobbyPaid && !lobbyFree && lobbyUnknown) {
            hotel.wifiDescription = 'В номере нет, в лобби есть';
        }

        hotel.withKidsDescription = 'Отдых с детьми';
        // Детский бассейн - 111
        // Детский клуб - 112
        // Водные горки -175
        // Кроватка - 114
        // Детское меню - 163
        let withKidsAttrsCounter = 0;
        const withKidsDescriptionsArray = [];
        if (attributeIds.has(111)) {
            withKidsDescriptionsArray.push('Детский бассейн');
            withKidsAttrsCounter++;
        }
        if (attributeIds.has(112)) {
            withKidsDescriptionsArray.push('Детский клуб');
            withKidsAttrsCounter++;
        }
        if (attributeIds.has(175)) {
            withKidsDescriptionsArray.push('Водные горки');
            withKidsAttrsCounter++;
        }
        if (attributeIds.has(114)) {
            if (withKidsDescriptionsArray.length < 3) {
                withKidsDescriptionsArray.push('Кроватка');
            }
            withKidsAttrsCounter++;
        }
        if (attributeIds.has(163)) {
            if (withKidsDescriptionsArray.length < 3) {
                withKidsDescriptionsArray.push('Детское меню');
            }
            withKidsAttrsCounter++;
        }
        if (withKidsAttrsCounter > 2) {
            hotel.withKids = true;
        }
        if (withKidsDescriptionsArray.length) {
            hotel.withKidsDescription = withKidsDescriptionsArray.join(', ');
        }
        if (hotel.adultsOnly && hotel.withKids) {
            hotel.adultsOnly = false;
            hotel.withKids = false;
        }

        hotel.beachDescription = '';
        // Шезлонги и зонтики на пляже (бесплатно) - 103
        // Шезлонги и зонтики на пляже (платно) - 104
        // Шезлонги и зонтики на пляже (нет данных о стоимости) - 243
        if (attributeIds.has(103)) {
            hotel.beachDescription = 'Шезлонги и зонтики бесплатно';
        } else if (attributeIds.has(104)) {
            hotel.beachDescription = 'Шезлонги и зонтики платно';
        } else if (attributeIds.has(243)) {
            hotel.beachDescription = 'Шезлонги и зонтики есть';
        }
        if (Array.isArray(element)) {
            WATER_ACTIVITIES_REPOSITORY.forEach((item) => {
                if (Array.isArray(item.id)) {
                    item.id.forEach((id) => {
                        if (attributeIds.has(id)) {
                            hotel[item.name] = true;
                        }
                    });
                } else if (attributeIds.has(item.id)) {
                    hotel[item.name] = true;
                }
            });
        }

        if (attributeIds.has(186) // бассейн
        || attributeIds.has(60) // открытый бассейн
        || attributeIds.has(59) // крытый бассейн
        || attributeIds.has(174) // с подогревом
        || attributeIds.has(173) // c морской водой
        || attributeIds.has(111) // детский бассейн
        || attributeIds.has(151)) { // термальный бассейн
            hotel.pool = true;
        }

        if (attributeIds.has(166)) {
            hotel.withAnimals = true;
        }

        if (attributeIds.has(147)) {
            hotel.spaAndHealth = true;
        }
    }

    element = data.distances;
    const { placement } = data;

    if ((typeof element !== 'undefined'
            && ((element.beachMax > 0 && element.beachMax < 500) || (element.beach > 0 && element.beach < 500)))
            || (typeof placement !== 'undefined' && placement > 0)
        ) {
        hotel.nearTheBeach = true;
        hotel.nearTheBeachDescription = '';
        if (placement === 1) {
            hotel.nearTheBeachDescription = '1-я линия';
        } else if (placement === 2) {
            hotel.nearTheBeachDescription = '1-я линия, пляж через дорогу';
        }
    }
    hotel.nearTheCenterDescription = '';
    if (typeof element !== 'undefined' && element.center > 0 && element.center < 1000) {
        hotel.nearTheCenter = true;
    }

    if (typeof element !== 'undefined') {
        if (typeof element.beachMax !== 'undefined'
            && element.beachMax !== null
            && element.beachMax !== 0
            && (element.beach === null || element.beach === 0)
        ) {
            element.beach = element.beachMax;
        }
        hotel.distances = element;
    }

    if ((typeof element !== 'undefined' && ((element.lift > 0 && element.lift <= 500)))) {
        hotel.nearTheLift = true;
    }

    hotel.facilities = getPropertyFacilitiesAttributes(data.types, data.attributes)

    hotel.tourProducts = new TourProductsRepository();
    hotel.hotelOffers = new HotelOffersRepository();

    return hotel;
};
